//import { useSelector } from "react-redux"; //Vishy 2025-18-02 build warning - not used
import { api } from "./config/axiosConfig.js";
import { defineCancelApiObject } from "./config/axiosUtils.js";
import { store } from "../redux/Store.ts";
import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";

export const CommonAPI = {
  /////////////////////////
  // EVENTS
  ////////////////////////

  getChat: async (recieverId, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/chat/retrieve/" + recieverId,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  sendChat: async (recieverId, data, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/chat/send/" + recieverId,
        method: "POST",
        data: data,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  postNotes: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/notes",
        method: "POST",
        data: data,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  getNotes: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/notes",
        method: "GET",
        params: params,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  getNotifications: async (cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/notifications",
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  markAllNotificationsAsRead: async (cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "notifications/mark-all-as-read",
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: Add API call to clear all notifications 09-02-2026
  clearAllNotifications: async (cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/notifications/clear-all",
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Meeting
  PostCreateMeeting: async (id, data, cancel = false) => {
    const { token } = await store.getState().user;
    console.log("CommonAPI.js - PostCreateMeeting input data is:",data);
    try {
      const response = await api.request({
        url: "/meeting-requests/" + id,
        method: "POST",
        data: data,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
  CheckMeetingAcceptAllowed: async (
    meetId,
    date = "",
    time = "",
    responderId = "",
    params,
    cancel = false
  ) => {
    const { token } = await store.getState().user;

    try {
      const queryParams = new URLSearchParams();
      if (date) queryParams.append("date", date);
      if (time) queryParams.append("time", time);
      if (responderId) queryParams.append("responderId", responderId);
  
      let url = `/meeting-requests/${meetId}`;
      if (queryParams.toString()) {
        url += `?${queryParams.toString()}`;
      }
      // let url =
      //   date && time
      //     ? "/meeting-requests/" + meetId + `?date=${date}&time=${time}`
      //     : "/meeting-requests/" + meetId;
      const response = await api.request({
        url,
        method: "GET",
        params: params,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  CheckMeetingChangeAllowed: async (
    meetId,
    date,
    time,
    params,
    cancel = false
  ) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: `/meeting-requests/${meetId}?date=${date}&time=${time}`,
        method: "GET",
        params: params,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  GetMeeting: async (params, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/meeting-requests",
        method: "GET",
        params: params,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
  // Claude: N44 — update meetingURL for a confirmed meeting 26-03-2026
  updateMeetingUrl: async (id, meetingURL) => {
    const { token } = await store.getState().user;
    try {
      const response = await api.request({
        url: `/meeting-requests/${id}/url`,
        method: 'PATCH',
        data: { meetingURL },
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  UpdateMeeting: async (id, data, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/meeting-requests/" + id,
        method: "PATCH",
        data: data,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      console.log(response);
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
  // Claude: autosuggest country search for buyer filter 25-02-2026
  searchSellerCountries: async (q = '') => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: 'sellers/distinct-countries',
      method: 'GET',
      params: { q },
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  // Claude: fetch industry tree for autosuggest 27-02-2026
  getIndustry: async () => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: 'taxonomy',
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
    return responseHandler(response);
  },

  // Claude: Fetch KB question strings for autosuggest — role-scoped, active only 26-03-2026
  getAiQuestions: async (role) => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: `/ai-knowledge/questions?role=${role}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: Fetch AI welcome message for role from KB 15-03-2026
  getAiWelcome: async (role) => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: `/ai-knowledge/welcome?role=${role}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: Send message to AI chat backend (Gemini + MongoDB function calling) 16-02-2026
  sendAiMessage: async (data, cancel = false) => {
    const { token } = await store.getState().user;

    try {
      const response = await api.request({
        url: "/ai-chat/message",
        method: "POST",
        data: data,
        headers: { Authorization: `Bearer ${token}` },
        signal: cancel
          ? cancelApiObject[this.get.name].handleRequestCancellation().signal
          : undefined,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
  // Claude: submit feedback from AI chat — buyer or seller 26-03-2026
  submitFeedback: async (data) => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: "/feedback",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data,
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
};

const cancelApiObject = defineCancelApiObject(CommonAPI);
